import { render, staticRenderFns } from "./BlockUpdate.vue?vue&type=template&id=7d142ec2&"
import script from "./BlockUpdate.vue?vue&type=script&lang=ts&"
export * from "./BlockUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports